<template>
    <div :class="['custom-control', switchMode ? 'custom-switch' : 'custom-checkbox']">
        <input
            v-bind="$attrs"
            :id="resolvedId"
            class="custom-control-input"
            type="checkbox"
            :checked="isChecked"
            :disabled="disabled"
            :value="nativeValue"
            @change="update($event.target.checked)"
        >
        <label class="custom-control-label" :for="resolvedId"><slot /></label>
    </div>
</template>
<script>
import { emitModel } from "./model";
let nextId = 0;
export default {
    name: "SbFormCheckbox",
    emits: ["update:modelValue", "change"],
    inheritAttrs: false,
    props: {
        modelValue: { default: undefined },
        checked: { default: undefined },
        uncheckedValue: { default: false },
        nativeValue: { default: true },
        id: { type: String, default: null },
        disabled: { type: Boolean, default: false },
        switch: { type: Boolean, default: false },
    },
    data() { return { generatedId: `sb-checkbox-${++nextId}` }; },
    computed: {
        resolvedId() { return this.id || this.generatedId; },
        switchMode() { return this.switch; },
        currentValue() {
            if (this.checked !== undefined) { return this.checked; }
            return this.modelValue;
        },
        isChecked() {
            if (Array.isArray(this.currentValue)) { return this.currentValue.includes(this.nativeValue); }
            return this.currentValue === this.nativeValue || this.currentValue === true;
        },
    },
    methods: {
        update(checked) {
            let value;
            if (Array.isArray(this.currentValue)) {
                value = this.currentValue.filter((item) => item !== this.nativeValue);
                if (checked) { value.push(this.nativeValue); }
            } else {
                value = checked ? this.nativeValue : this.uncheckedValue;
            }
            emitModel(this, value);
            this.$emit("change", value);
        },
    },
};
</script>
